import React from "react";
import WhatsAppSignup from "./WhatsAppSignup";
import { useSearchParams } from 'react-router-dom';

const WhatsAppSettings = () => {
    const [searchParams] = useSearchParams();
    const memberId = searchParams.get('id');
    /*const auth = getAuth();

    const getIdToken = async () => {
        const user = auth.currentUser;

        if (!user) {
            throw new Error(
                "Please sign in to MemberMeld first."
            );
        }

        return user.getIdToken();
    };*/

    return (
        <WhatsAppSignup
            appId={process.env.REACT_APP_META_APP_ID}
            configId={process.env.REACT_APP_META_CONFIG_ID}
            backendUrl={process.env.REACT_APP_API_BASE_URL}
            //getIdToken={getIdToken}
            clubId={memberId}
            onConnected={(result) => {
                console.log(
                    "WhatsApp connection completed",
                    result
                );
                // Refresh MemberMeld's WhatsApp connection status.
            }}
        />
    );
};

export default WhatsAppSettings;
